import API from 'services/API';

export default function resetPassword(data) {
  return API.request({
    method: 'POST',
    url: '/profile/submitPassword',
    data,
  });
}
